export default "__VITE_ASSET__aDPdzb4V__"